// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.divider_divider_Ny838 {
    border-right: 1px dashed var(--ui-black-transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/divider/divider.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,oDAAoD;AACxD","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.divider {\n    border-right: 1px dashed var(--ui-black-transparent);\n}\n"],"sourceRoot":""}]);
// Exports
export var divider = `divider_divider_Ny838`;
export default ___CSS_LOADER_EXPORT___;
